import componentModelFilters from '@/app/settings/modules/errands/component-settings/component-models/components/filters';
import { cn } from '@/lib/cn';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  ComponentModelConfig,
  type ComponentModel,
} from '@pigello/pigello-matrix';
import Dot from './dot';
import type { RelationFieldProps } from './types';
export const ComponentModelItem: RelationFieldProps<ComponentModel> = {
  nested: getRelationFieldNames(ComponentModelConfig),
  filters: componentModelFilters,
  renderItem: (item, isRelationField) => ({
    title: item?.name,
    descriptionItems: (
      <div
        className={cn(
          'flex w-full items-center',
          isRelationField && 'justify-between'
        )}
      >
        <span className='font-medium'>{item?.articleNumber}</span>
        {!isRelationField && <Dot />}
        <span className='font-medium'>{item?.componentType?.name}</span>
        {!isRelationField && item.make != null && <Dot />}
        <span className='font-medium'>{item?.make ?? ""}</span>
      </div>
    ),
  }),
};
